import { css } from "@emotion/react";

export const wordWrap = css`
  word-wrap: anywhere;
`;
